export const SECTION_IDS = [
	'home',
	'ai-indicator',
	'skills',
	'experience',
	'projects',
	'contact',
] as const

export type SectionId = (typeof SECTION_IDS)[number]

export const DEFAULT_SECTION: SectionId = 'home'
